// eslint-disable-next-line
import { produce } from 'immer';

const INITIAL_VALUES = {
  theme: '',
  price: null,
  end_date: false,
  start_date: '',
  modules: null,
};

export const SESSION_LOAD = 'SESSION_LOAD';

const sessionReducer = (state = INITIAL_VALUES, action) =>
  // eslint-disable-next-line
  produce(state, draft => {
    switch (action.type) {
      case SESSION_LOAD:
        // Utiliser Object.assign pour charger le document
        return Object.assign(draft, action.payload);
      default:
        return draft;
    }
  });

export default sessionReducer;
